// extracted by mini-css-extract-plugin
module.exports = {"atfContainer":"_3aVEdt"};